import { Reducer } from 'react';

import { Actions } from '../actions/Actions';
import { isFeatureFlagsChanged } from '../actions/FeatureFlagsChanged';
import { createGoal } from '../actions/goals/Goal';
import { kind as restart } from '../actions/goals/Restart';
import { addGoal } from '../GoalResolvers';
import { State } from '../State';
import { reduceLifeCycle } from './lifecycle/reduceLifeCycle';
import { reduceAction } from './reduceAction';

export const reducer: Reducer<State, Actions> = (state, action) => {
  // Record key feature flags before we push any changes.
  const { syncFamilies: usingFamilies } = state.featureFlags;

  let nextState: State = state;
  nextState = reduceAction(nextState, action);

  if (isFeatureFlagsChanged(action)) {
    // restart replication with the new `syncFamilies` setting
    if (usingFamilies !== action.featureFlags.syncFamilies && state.replication) {
      const goalResolvers = addGoal(state.goalResolvers, createGoal(restart));
      nextState = {
        ...nextState,
        goalResolvers,
      };
    }
  }
  nextState = reduceLifeCycle(nextState);
  // TODO: clean this up once we're comfortable with the process. https://nutrien.atlassian.net/browse/MDP-8188.
  // Log this to Debug so that we can see what's happened without having to enable a flag.
  // TODO: clean this up once we're comfortable with the process. https://nutrien.atlassian.net/browse/MDP-8188.
  // eslint-disable-next-line no-console
  console.debug('Reduce Replication', state, action, nextState);
  return nextState;
};
